<template>
  <section class="band stats-band">
    <div class="wrap">
      <div class="stats">
        <div><span class="k">Network</span><b>1,000+</b><p>screens powered by Adverpost to date</p></div>
        <div><span class="k">Pro plan</span><b>$69</b><p>a month for every Pro feature</p></div>
        <div><span class="k">Global</span><b>3</b><p>countries with local support teams</p></div>
        <div><span class="k">Uptime</span><b>24/7</b><p>content keeps playing offline, with uptime monitoring</p></div>
      </div>
    </div>
  </section>
</template>

<script> 
// Extracted from the published landing page; in-page anchors emit instead of
// navigating, because the app uses a hash router.
export default { name: "StatsBand" };
</script>
